import type { RefObject } from 'react';

export const DEPTH_COLORS = ['#5c6bc0', '#26a69a', '#ef6c00', '#ab47bc', '#42a5f5'];

export const getDepthColor = (depth: number) => DEPTH_COLORS[depth % DEPTH_COLORS.length];

export const SKELETON_WIDTHS = [100, 140, 80];

export interface TaxonomyTreeProperties {
  taxonomyId: string;
  isItemExpanded: (id: string) => boolean;
  addExpandedItems: (ids: string[]) => void;
  expandAllActive: boolean;
  addingChildOfId?: string;
  isCreating: boolean;
  onAddChild: (parentId: string) => void;
  onSubmitChild: (name: string) => void;
  onCancelAdd: () => void;
  renamingNodeId?: string;
  isRenaming: boolean;
  onStartRename: (nodeId: string) => void;
  onRenameNode: (nodeId: string, newName: string) => void;
  onCancelRename: () => void;
  onDeleteNode: (nodeId: string, nodeName: string, hasChildren: boolean) => void;
  scrollContainerReference: RefObject<HTMLElement | null>;
  searchVisibleIds?: Set<string>;
  searchMatchIds?: Set<string>;
}
